import React from 'react';
import { motion } from 'framer-motion';
import { TargetIcon } from 'lucide-react';
export function TargetSection() {
  const targets = ['Ha tenido demasiados cortes "más o menos" y está listo para exigir más', 'Quiere llegar al lunes sintiéndose como el dueño de la sala', 'Toma su apariencia en serio porque toma su vida en serio', 'Sabe que cómo te presentas refleja tus estándares', 'Está listo para dejar de visitar una barbería — y empezar a vivir una experiencia'];
  return <section className="bg-delux-alt py-20 px-4 sm:px-6 lg:px-8 border-y border-delux-gold/10" data-id="element-323">
      <div className="max-w-4xl mx-auto" data-id="element-324">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-325">
          <TargetIcon className="w-12 h-12 text-delux-gold mx-auto mb-6" data-id="element-326" />
          <h2 className="font-heading text-3xl md:text-4xl text-delux-gold mb-10" data-id="element-327">
            Esto Es Para El Hombre Que...
          </h2>
        </motion.div>

        <div className="bg-delux-card p-8 md:p-12 rounded-lg border border-delux-gold/20 shadow-xl" data-id="element-328">
          <ul className="space-y-6" data-id="element-329">
            {targets.map((target, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start" data-id="element-330">
                <span className="text-delux-gold mr-4 text-2xl leading-none mt-1" data-id="element-331">
                  •
                </span>
                <span className="font-body text-lg md:text-xl text-delux-white" data-id="element-332">
                  {target}
                </span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="mt-10 pt-8 border-t border-delux-gold/20 text-center" data-id="element-333">
            <p className="font-heading text-2xl text-delux-gold italic" data-id="element-334">
              Si eso te suena familiar, ya encontraste tu lugar.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}